
  import { defineComponent } from 'vue';
  import { bool, string } from 'vue-types';
  
  export default defineComponent({
    name: 'CameraStatusInfoText',
    props: {
      modelValue: string().isRequired,
      description:string().isRequired,
      isVideoArchive:bool().isRequired,
      defaultClass:string().isRequired,
    }
  });
  
  